import*as t from"react";const e=t.createContext({});"production"!==process.env.NODE_ENV&&(e.displayName="ListContext");var o=e;export{o as L};
